import { useAndroidRecaptcha } from "./recaptcha-android"
import { useWebRecaptcha } from "./recaptcha-web"

export const useRecaptcha = defineComposable("recaptcha", () => {
	const platform = useWebPlatform()

	if (platform === "web")
		return useWebRecaptcha()

	else if (platform === "android")
		return useAndroidRecaptcha()

	else
		throw new Error(`Recaptcha Not Implemented for ${platform}`)
})
